import script from "./withdrawal.vue?vue&type=script&setup=true&lang=js"
export * from "./withdrawal.vue?vue&type=script&setup=true&lang=js"

import "./withdrawal.vue?vue&type=style&index=0&id=7be556a3&lang=css"

const __exports__ = script;

export default __exports__